'use client';

import { useEffect, useRef, Suspense } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { createPageViewTracker } from '@/lib/analytics/page-views';

function PageViews({ ymId }: { ymId?: string | number | null }) {
  const pathname = usePathname();
  const search = useSearchParams().toString();
  const tracker = useRef<ReturnType<typeof createPageViewTracker> | null>(null);
  useEffect(() => {
    if (!ymId) return;
    if (!tracker.current) {
      tracker.current = createPageViewTracker(window.location.href);
      return;
    }
    let attempts = 0;
    let timer: ReturnType<typeof setTimeout>;
    const report = () => {
      tracker.current?.(window.location.href, (url, referer) => {
        if (typeof window.ym !== 'function') return false;
        window.ym(String(ymId), 'hit', url, { referer, title: document.title });
        return true;
      });
      if (typeof window.ym !== 'function' && ++attempts < 10) timer = setTimeout(report, 300);
    };
    report();
    return () => clearTimeout(timer);
  }, [pathname, search, ymId]);
  return null;
}

export default function YandexMetrikaPageViews(props: { ymId?: string | number | null }) {
  return <Suspense fallback={null}><PageViews {...props} /></Suspense>;
}
